module.exports = __webpack_public_path__ + "img/schedule.6c0dd423.jpg";